import React from "react";
import { fill } from "lodash";
import { InputBasic, SelectBasic } from "components/common/form";
import { CheckboxWithLabel } from "components/haven-design/form/checkbox";

import {
  QueryInterestFormData,
  QueryInterestFormData_applicationFormMetadata_schema_options as SchemaOptionType,
} from "types/gql-types";
import { Column } from "components/common/html";

type ValidationSchema = NonNullable<QueryInterestFormData["applicationFormMetadata"]>["schema"]

// determine if a field name is present in form schema
// isFieldInSchema(string, list(map)):: boolean
export const isFieldInSchema = (fieldName: string, schema = [] as ValidationSchema):boolean =>
  (schema ? (
    schema
      .map((schemaItem: NonNullable<ValidationSchema>[number]) => schemaItem?.name === fieldName)
      .includes(true)) : false);

export const getLabelFromSchema = (schema: ValidationSchema, inputName: string): string => {
  if (!schema) return "No label found";
  const item = schema.filter(x => x && x.name === inputName)[0] || { label: "No label found" };
  return item.label || "No label found";
};

// little helper component to autohide fields not used
// for a specific property
// {name: string, vs: ValidationSchema}
export const ShouldRenderField: React.FC<any> = (props) => {
  if (props.children && isFieldInSchema(props.name, props.vs)) {
    return props.children;
  }
  return null;
};

// create a list of maps with each member name
export const gatherAllHouseholdMembers = (formData: Record<string, any>): {name: string}[] =>
  fill(Array(Number(formData.household_count || 0)), null).map((_data, i) => ({
    name: `${formData[`household_member_${i}_first_name`]} ${
      formData[`household_member_${i}_last_name`]
    }`,
  }));

// wrapper components to reduce boilerplate

export const Input: React.FC<any> = (props) =>
  <InputBasic {...props} defaultValue={props.formData[props.name]} />;

export const Checkbox: React.FC<any> = ({ inline, formData, ...props }) => (
  <div style={{ display: inline ? "inline-block" : "block" }}>
    <CheckboxWithLabel
      defaultChecked={formData[props.name]}
      {...props}
      style={{ marginLeft: -5 }}
    />
  </div>
);

export const Select: React.FC<any> = props => (
  <Column width={props.width}>
    <SelectBasic defaultValue={props.formData[props.name]} {...props} />
  </Column>
);

export const getUnitSizeOptions = (schema: ValidationSchema): SchemaOptionType[] => {
  if (!schema) return [];
  const unitSize = schema.find((question) => question && question.name === "unit_size");
  return (unitSize && unitSize.options) || [];
};
